<div class="step-wrapper">
  <span
    i18n="
      XMSG|Suite Step Review intro
      text@@organizations.unified-suite-step-review.stepReviewIntroText"
  >
    Review your data before setting up your product blueprint in the unified
    services framework. <br /><br />
    TIP: Some fields are editable in this review step. Hover over the displayed
    values and click Edit. Other fields can only be updated by going back to the
    previous step.
  </span>

  <h3 class="section-title">Basic Info</h3>
  <app-container
    [body]="basicInfoContainer"
    class="margin-bottom"
  ></app-container>
  <ng-template #basicInfoContainer>
    @if (!!form.controls[PAYLOAD_FORM_GROUPS.PAYLOAD]) {
      <div class="margin-bottom">
        <app-unified-review-row
          label="Folder"
          [placeholder]="BASE_PLACEHOLDER"
          [control]="
            $any(
              form.controls[PAYLOAD_FORM_GROUPS.PAYLOAD].get(
                PAYLOAD_FORM_CONTROLS.BASE_FOLDER_NAME
              )
            )
          "
        ></app-unified-review-row>
        <app-unified-review-row
          label="Resource Group"
          [placeholder]="BASE_PLACEHOLDER"
          [control]="
            $any(
              form.controls[PAYLOAD_FORM_GROUPS.PAYLOAD].get(
                PAYLOAD_FORM_CONTROLS.RESOURCE_GROUP_NAME
              )
            )
          "
        ></app-unified-review-row>
        <app-unified-review-row
          label="Test Folder"
          [placeholder]="BASE_PLACEHOLDER"
          [control]="
            $any(
              form.controls[PAYLOAD_FORM_GROUPS.PAYLOAD].get(
                PAYLOAD_FORM_CONTROLS.TEST_FOLDER_NAME
              )
            )
          "
        ></app-unified-review-row>
        <app-unified-review-row
          label="Test Resource Group"
          [placeholder]="BASE_PLACEHOLDER"
          [control]="
            $any(
              form.controls[PAYLOAD_FORM_GROUPS.PAYLOAD].get(
                PAYLOAD_FORM_CONTROLS.TEST_RESOURCE_GROUP_NAME
              )
            )
          "
        ></app-unified-review-row>
        <div class="margin-top"></div>
        <h3 class="section-title sub-section-title">Managed Service</h3>
        <app-unified-review-row
          label="Name"
          [placeholder]="BASE_PLACEHOLDER"
          [control]="
            $any(
              form.controls[PAYLOAD_FORM_GROUPS.PAYLOAD].get(
                PAYLOAD_FORM_CONTROLS.MANAGED_SERVICE_NAME
              )
            )
          "
        ></app-unified-review-row>
      </div>
    }
    <div>
      <h3 class="section-title sub-section-title">
        Service Publish Configuration
      </h3>
      <app-unified-review-row
        label="Name"
        [placeholder]="BASE_PLACEHOLDER"
        [control]="
          $any(
            form.controls[PAYLOAD_FORM_GROUPS.PAYLOAD]
              .get(PAYLOAD_FORM_GROUPS.SERVICE_PUBLISH_CONFIGURATION)
              .get(PAYLOAD_FORM_CONTROLS.SERVICE_PUBLISH_CONFIGURATION.NAME)
          )
        "
      ></app-unified-review-row>
    </div>
  </ng-template>

  <h3 class="section-title">Product Blueprint Metadata</h3>
  <app-container [body]="productMetadata" class="margin-bottom"></app-container>
  <ng-template #productMetadata>
    <div class="margin-bottom">
      <h3 class="section-title sub-section-title">Service Metadata</h3>
      <app-unified-review-row
        label="Name"
        [placeholder]="BASE_PLACEHOLDER"
        [control]="
          $any(
            form.controls[STEP_SETUP_FORM_GROUPS.STEP_SETUP]
              .get(STEP_SETUP_FORM_GROUPS.SERVICE_METADATA)
              .get(STEP_SETUP_FORM_CONTROLS.SERVICE_METADATA.NAME)
          )
        "
      ></app-unified-review-row>
      <span class="container-title">Product Blueprint:</span>
      <div class="product-suite-container">
        <app-unified-review-row
          label="Name"
          [value]="
            form.controls[STEP_SETUP_FORM_GROUPS.STEP_SETUP]
              .get(STEP_SETUP_FORM_GROUPS.SERVICE_METADATA)
              .get(STEP_SETUP_FORM_CONTROLS.SERVICE_METADATA.SUITE_NAME).value
          "
        ></app-unified-review-row>
        <app-unified-review-row
          label="Display Name"
          [placeholder]="BASE_PLACEHOLDER"
          [control]="
            $any(
              form.controls[STEP_SETUP_FORM_GROUPS.STEP_SETUP]
                .get(STEP_SETUP_FORM_GROUPS.SERVICE_METADATA)
                .get(STEP_SETUP_FORM_CONTROLS.SERVICE_METADATA.DISPLAY_NAME)
            )
          "
        ></app-unified-review-row>
        <app-unified-review-row
          label="Description"
          [placeholder]="BASE_PLACEHOLDER"
          [control]="
            $any(
              form.controls[STEP_SETUP_FORM_GROUPS.STEP_SETUP]
                .get(STEP_SETUP_FORM_GROUPS.SERVICE_METADATA)
                .get(STEP_SETUP_FORM_CONTROLS.SERVICE_METADATA.DESCRIPTION)
            )
          "
        ></app-unified-review-row>
        <app-unified-review-row
          label="Tenant Product Type"
          [placeholder]="BASE_PLACEHOLDER"
          [control]="
            $any(
              form.controls[STEP_SETUP_FORM_GROUPS.STEP_SETUP]
                .get(STEP_SETUP_FORM_GROUPS.SERVICE_METADATA)
                .get(
                  STEP_SETUP_FORM_CONTROLS.SERVICE_METADATA.TENANT_PRODUCT_TYPE
                )
            )
          "
        ></app-unified-review-row>
        <app-unified-review-row
          label="Documentation URL"
          [placeholder]="BASE_PLACEHOLDER"
          [control]="
            $any(
              form.controls[STEP_SETUP_FORM_GROUPS.STEP_SETUP]
                .get(STEP_SETUP_FORM_GROUPS.SERVICE_METADATA)
                .get(
                  STEP_SETUP_FORM_CONTROLS.SERVICE_METADATA.DOCUMENTATION_URL
                )
            )
          "
        ></app-unified-review-row>
        <app-unified-review-row
          label="Icon URL"
          [placeholder]="BASE_PLACEHOLDER"
          [control]="
            $any(
              form.controls[STEP_SETUP_FORM_GROUPS.STEP_SETUP]
                .get(STEP_SETUP_FORM_GROUPS.SERVICE_METADATA)
                .get(STEP_SETUP_FORM_CONTROLS.SERVICE_METADATA.ICON_URL)
            )
          "
        ></app-unified-review-row>

        <app-unified-review-row
          label="Set Up as Package"
          [placeholder]="BASE_PLACEHOLDER"
          [value]="
            form.controls[STEP_SETUP_FORM_GROUPS.STEP_SETUP]
              .get(STEP_SETUP_FORM_GROUPS.SERVICE_METADATA)
              .get(STEP_SETUP_FORM_CONTROLS.SERVICE_METADATA.PACKAGE).value ===
            true
              ? 'Yes'
              : 'No'
          "
        >
        </app-unified-review-row>

        <app-unified-review-row
          label="Category"
          [placeholder]="BASE_PLACEHOLDER"
          [value]="
            form.controls[STEP_SETUP_FORM_GROUPS.STEP_SETUP]
              .get(STEP_SETUP_FORM_GROUPS.SERVICE_METADATA)
              .get(STEP_SETUP_FORM_CONTROLS.SERVICE_METADATA.CATEGORY).value
          "
        >
        </app-unified-review-row>
      </div>
    </div>
  </ng-template>

  <div class="business-types-container">
    @for (
      businessTypeControl of businessTypes?.controls;
      track businessTypeControl
    ) {
      <h3 class="section-title business-type-title">
        Business Type: {{ businessTypeControl.get("title").value }}
      </h3>
      <app-container [body]="businessTypesTemplate"></app-container>
      <ng-template #businessTypesTemplate>
        <div class="margin-bottom">
          <h3 class="section-title sub-section-title">BTP Blueprint</h3>
          <app-unified-review-row
            label="Name"
            [placeholder]="BASE_PLACEHOLDER"
            [control]="
              $any(businessTypeControl.get('btpBlueprint').get('name'))
            "
          ></app-unified-review-row>
          <span class="container-title">Business Type:</span>
          <div class="business-type-container">
            <app-unified-review-row
              label="Title"
              [value]="businessTypeControl.get('title').value"
            ></app-unified-review-row>
            <app-unified-review-row
              label="Code"
              [value]="businessTypeControl.get('code').value"
            ></app-unified-review-row>
          </div>
        </div>
        <h3 class="section-title sub-section-title">
          Resource Type Definition (Solution)
        </h3>
        <app-unified-review-row
          label="Group"
          [placeholder]="BASE_PLACEHOLDER"
          [control]="
            $any(
              businessTypeControl
                .get('resourceTypeDefinition')
                .get(STEP_SETUP_FORM_CONTROLS.RESOURCE_TYPE_DEFINITION.GROUP)
            )
          "
          [customErrorMessage]="
            CUSTOM_VALIDATION_ERRORS.RESOURCE_TYPE_DEFINITION.GROUP
          "
        ></app-unified-review-row>
        <app-unified-review-row
          label="Version"
          [placeholder]="BASE_PLACEHOLDER"
          [control]="
            $any(
              businessTypeControl
                .get('resourceTypeDefinition')
                .get(STEP_SETUP_FORM_CONTROLS.RESOURCE_TYPE_DEFINITION.VERSION)
            )
          "
          [customErrorMessage]="
            CUSTOM_VALIDATION_ERRORS.RESOURCE_TYPE_DEFINITION.VERSION
          "
        ></app-unified-review-row>
        <app-unified-review-row
          label="Type"
          [placeholder]="BASE_PLACEHOLDER"
          [control]="
            $any(
              businessTypeControl
                .get('resourceTypeDefinition')
                .get(STEP_SETUP_FORM_CONTROLS.RESOURCE_TYPE_DEFINITION.TYPE)
            )
          "
          [customErrorMessage]="
            CUSTOM_VALIDATION_ERRORS.RESOURCE_TYPE_DEFINITION.TYPE
          "
        ></app-unified-review-row>
        <app-unified-review-row
          label="Plural"
          [placeholder]="BASE_PLACEHOLDER"
          [control]="
            $any(
              businessTypeControl
                .get('resourceTypeDefinition')
                .get(STEP_SETUP_FORM_CONTROLS.RESOURCE_TYPE_DEFINITION.PLURAL)
            )
          "
          [customErrorMessage]="
            CUSTOM_VALIDATION_ERRORS.RESOURCE_TYPE_DEFINITION.SINGULAR_PLURAL
          "
        ></app-unified-review-row>
        <app-unified-review-row
          label="Singular"
          [placeholder]="BASE_PLACEHOLDER"
          [control]="
            $any(
              businessTypeControl
                .get('resourceTypeDefinition')
                .get(STEP_SETUP_FORM_CONTROLS.RESOURCE_TYPE_DEFINITION.SINGULAR)
            )
          "
          [customErrorMessage]="
            CUSTOM_VALIDATION_ERRORS.RESOURCE_TYPE_DEFINITION.SINGULAR_PLURAL
          "
        ></app-unified-review-row>
      </ng-template>
    }
  </div>
</div>
